"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChainConnectionInfo = /** @class */ (function () {
    function ChainConnectionInfo(chainId, url) {
        this.chainId = chainId;
        this.url = url;
    }
    return ChainConnectionInfo;
}());
exports.default = ChainConnectionInfo;
//# sourceMappingURL=chain-connection-info.js.map